if (!customElements.get('kw-show-more')) {
  customElements.define('kw-show-more', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('.kw-show-more__button');
      this.status = this.querySelector('.kw-show-more__count');
      this.error = this.querySelector('.kw-show-more__error');
      this.onClick = this.loadMore.bind(this);
      this.link?.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.link?.removeEventListener('click', this.onClick);
    }

    async loadMore(event) {
      // Preserve normal links for new tabs, keyboard modifiers and no JavaScript.
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (this.loading) return;
      const container = this.closest('#ProductGridContainer');
      const grid = container?.querySelector('#product-grid');
      if (!grid || grid.closest('.collection')?.classList.contains('loading')) return;
      const url = new URL(this.link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      url.searchParams.set('section_id', this.dataset.sectionId);
      this.loading = true;
      this.controller = new AbortController();
      const label = this.link.textContent;
      this.link.textContent = this.dataset.loadingLabel;
      this.link.setAttribute('aria-disabled', 'true');
      this.setAttribute('aria-busy', 'true');
      this.error.hidden = true;

      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Collection request failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = page.querySelector('#product-grid');
        if (!nextGrid || nextGrid.dataset.id !== this.dataset.sectionId) throw new Error('Invalid collection response');
        // Filters replace the grid. Never append an old response to new results.
        if (!this.isConnected || container.querySelector('#product-grid') !== grid || grid.closest('.collection')?.classList.contains('loading')) return;
        const existingIds = new Set(Array.from(grid.querySelectorAll('[data-product-id]'), (item) => item.dataset.productId));
        const items = Array.from(nextGrid.children).filter((item) => item.dataset.productId && !existingIds.has(item.dataset.productId));
        if (!items.length) throw new Error('No additional products returned');
        const fragment = document.createDocumentFragment();
        for (const item of items) {
          item.classList.add('scroll-trigger--cancel');
          fragment.append(item);
        }
        grid.append(fragment);
        const nextControl = page.querySelector('kw-show-more');
        const nextLink = nextControl?.querySelector('.kw-show-more__button');
        if (nextLink) this.link.href = nextLink.getAttribute('href');
        else this.link.hidden = true;
        const oldPagination = this.querySelector('.pagination-wrapper');
        const nextPagination = nextControl?.querySelector('.pagination-wrapper');
        if (oldPagination && nextPagination) oldPagination.replaceWith(nextPagination);
        else oldPagination?.remove();
        const total = nextControl?.dataset.total || this.dataset.total;
        this.status.textContent = this.dataset.countLabel
          .replace('[count]', grid.querySelectorAll('[data-product-id]').length)
          .replace('[total]', total);
        // Place keyboard focus at the start of the newly loaded products.
        items[0].querySelector('a')?.focus({ preventScroll: true });
        if (window.Shopify?.PaymentButton?.init) window.Shopify.PaymentButton.init();
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) {
          this.error.textContent = this.dataset.errorLabel;
          this.error.hidden = false;
        }
      } finally {
        this.loading = false;
        this.removeAttribute('aria-busy');
        this.link.textContent = label;
        this.link.removeAttribute('aria-disabled');
      }
    }
  });
}
